import { useEffect, useState } from "react";
import BarChartData from "./BarChart";
import NewBussinessChart from "./NewBussinessChart";
import PieChartComponent from "./PieChart";
import TotalChases from "./TotalChase";
import axiosInstance from "../utils/axiosInstance";

const filterTypes = ["Sales", "Renewals", "Standard", "Non-Standard"]

const typeColors: Record<string, string> = {
  Sales: "#6366F1",
  Renewals: "#14B8A6",
  Standard: "#F59E0B",
  "Non-Standard": "#F43F5E",
};

export default function Charts() {
  const [chartsData, setChartsData] = useState<Record<string, any>[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const getMainChartDetails = async () => {
      let promises = [];

      const getChartsData = async (type: string) => {
        setLoading(true)
        try {
          const res = await axiosInstance.get(`/stats/chase/types/compare?filterType=${type}`)
          return res.data
        } catch (error) {
          console.log(error)
        }
      }

      filterTypes.map((filterType) => {
        promises.push(
          new Promise(async (resolve, reject) => {
            try {
              const resData = await getChartsData(filterType)
              resolve(resData);
            } catch (error) {
              reject(error);
            }
          })
        )

        return filterType
      })

      const promisesRes = await Promise.all(promises);
      setChartsData(promisesRes)
      setLoading(false)
    }

    getMainChartDetails()
  }, [])


  return (
    <div className="grid grid-cols-3 gap-4 smallLaptop:grid-cols-1">
      <div className="col-span-2 h-[420px] smallLaptop:col-span-1 smallTablet:h-[380px] smallTablet:min-w-0">
        <BarChartData />
      </div>

      <div className="h-[420px] smallTablet:min-w-0">
        <PieChartComponent />
      </div>

      <div className="col-span-2 h-[320px] smallLaptop:col-span-1 smallTablet:h-[300px] smallTablet:min-w-0">
        <TotalChases />
      </div>

      <div className="h-[320px] rounded-2xl bg-surface border border-edge shadow-card px-5 py-5 flex flex-col animate-fade-in smallTablet:h-auto smallTablet:px-4 smallTablet:min-w-0">
        <div>
          <h1 className="text-[16px] font-bold text-text-primary">New chases by type</h1>
          <p className="mt-0.5 text-[13px] font-medium text-light-gray">Last 6 months</p>
        </div>

        <div className="grid grid-cols-2 grid-rows-2 gap-3 flex-1 min-h-0 mt-4 smallTablet:grid-rows-none smallTablet:auto-rows-[130px]">
          {loading
            ? filterTypes.map((filterType) => (
              <div
                key={filterType}
                className="w-full h-full animate-pulse bg-overlay-mid border border-edge-faint rounded-xl"
              />
            ))
            : chartsData?.map((chaseItem) => (
              <NewBussinessChart
                key={chaseItem?.type}
                name={chaseItem?.type}
                value={chaseItem?.totalCount}
                data={chaseItem?.data}
                color={typeColors[chaseItem?.type] ?? "#6366F1"}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
